// Image types
import {
  BackgroundAttachment,
  BackgroundPosition,
  BackgroundRepeat,
  BackgroundSize,
  DirectionRange,
} from "./util.types";

export enum MediaType {
  None = "none",
  Unsplash = "unsplash",
  Custom = "custom",
  Gradient = "gradient",
  Video = "video",
  Color = "color",
}

export const MediaTypeJSWithOrder = [
  ["color", "Color"],
  ["gradient", "Gradient"],
  // ["unsplash", "Unsplash"],
  ["video", "Video"],
  ["custom", "Image"],
];

export const MediaTypeJS = Object.fromEntries(MediaTypeJSWithOrder);

export interface MediaSourceMixin {
  src?: string | null; // link to uploaded
  aspectRatio?: number; // aspect ratio of image
  dataUrl?: string | null;
  position: BackgroundPosition;
  repeat: BackgroundRepeat;
  size: BackgroundSize;
  attachment: BackgroundAttachment;
}
export interface CustomMediaShape extends MediaSourceMixin {
  type: MediaType.Custom;
}
export interface GradientMediaShape {
  type: MediaType.Gradient;
  colorStart: string;
  colorEnd: string;
  direction: DirectionRange;
}
export interface VideoMediaShape extends MediaSourceMixin {
  type: MediaType.Video;
}

export interface ColorMediaShape {
  type: MediaType.Color;
  color: string | null; // hex i.e., "ffffff". If null color is undefined.
}

export type MediaShape =
  | CustomMediaShape
  | GradientMediaShape
  | VideoMediaShape
  | ColorMediaShape;
